const DATA_URI_PNG_PREFIX = "data:image/png;base64,";

export default DATA_URI_PNG_PREFIX;
